const roles = [
  {
    id: 0,
    role: 'admin',
    name: '超级管理员',
    accessIds: [100000, 100100, 100200, 110000, 110100, 110200, 110201, 110202],
  },
  {
    id: 1,
    role: 'editor',
    name: '管理员',
    accessIds: [110000, 110100, 110200, 110201, 110202],
  },
  {
    id: 2,
    role: 'user',
    name: '普通用户',
    accessIds: [],
  },
]

export function getRoles(params = {}) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        data: roles,
        total: roles.length,
      })
    }, 500)
  })
}

export function getUserAccess(params = {}) {
  const { role } = params

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const roleData = roles.find(item => item.role === role)

      resolve({
        success: true,
        message: '',
        data: roleData,
      })
    }, 500)
  })
}
